module.exports = __webpack_public_path__ + "img/health.c80148f5.jpg";